import { Option as MuiOption, type OptionProps } from '@mui/base'
import { useListItem } from '@mui/base/useList'
import { clsx } from 'clsx'
import { type ElementType, type JSX } from 'react'

import { IconCheck } from '@redteclab/icons'

export { type OptionProps } from '@mui/base'

export const Option = <OptionValue, RootComponentType extends ElementType>(
  props: OptionProps<OptionValue, RootComponentType>,
): JSX.Element => {
  const { children, className, value } = props

  const { highlighted, selected } = useListItem({
    item: value,
  })

  return (
    <MuiOption
      {...props}
      className={clsx(
        'option',
        highlighted && 'option_highlighted',
        selected && 'option_selected',
        className,
      )}
    >
      {children}
      {selected ? <IconCheck className="option__icon" /> : null}
    </MuiOption>
  )
}
